import { State } from "./State";
export class Message {
    constructor(id, roomId, enabled, text) {
        this.id = id;
        this.roomId = roomId;
        this.enabled = new State(enabled);
        this.text = new State(text);
    }
}
